module.exports = __webpack_public_path__ + "static/img/logError.b8a42f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logError.png
// module id = EJqJ
// module chunks = 1